import { render, staticRenderFns } from "./TabWeightChart.vue?vue&type=template&id=3bfaa4f4&scoped=true&"
import script from "./TabWeightChart.vue?vue&type=script&lang=js&"
export * from "./TabWeightChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfaa4f4",
  null
  
)

export default component.exports